import * as ActionTypes from 'actions/partnerChildrenForm'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
}

// Updates error message to notify about the failed fetches.
export default function partnerChildrenForm(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERCHILDREN_SAVE_REQUEST:
      return Object.assign({}, state, {
      })
    case ActionTypes.PARTNERCHILDREN_SAVE_COMPLETE:
      return {
        ...state,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerChildrenForm.js